import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'

export default class HeaderGroup extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  mount () {
    this._doScrollCalculations()

    document.body.style.paddingTop = this._elem.getBoundingClientRect().height + 'px';

    window.addEventListener('resize', e => {
      document.body.style.paddingTop = this._elem.getBoundingClientRect().height + 'px';
    }, { passive: true })

    window.addEventListener('scroll', e => {
     
      this._doScrollCalculations()
    }, { passive: true })
  }

  _doScrollCalculations () {
    if (window.scrollY === 0) {
      this._elem.classList.remove('is-scrolled')
      document.body.classList.remove('header-is-scrolled')
    } else {
      this._elem.classList.add('is-scrolled')
      document.body.classList.add('header-is-scrolled')
    }    
  }
}